module.exports = __webpack_public_path__ + "static/img/setup-bossint.2e329aef.png";